module.exports = "/_next/static/images/snaptrade-cc9acde51ff21fb42b98e89fee17e64f.svg";